
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogTagFR]",
      function () {
        return require("private-next-pages/[...blogTagFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogTagFR]"])
      });
    }
  